import gql from "graphql-tag";

export const SAVE_FILE_REPO = gql`
  subscription saveFileRepo(
    $archivo_b64: String
    $descripcion_archivo: String
    $formato_b64: String
    $id_empresa: String
    $id_usuario: String
    $nombre_archivo: String
    $tiempo: String
    $tipo_archivo: Int #2: videoMain. 4: banner. 5: bannerH.  6: ImagenMain
    $inputUri: String
    $filenameInputUri: String
    $fileName: String
    $imagen_b64: String
    $formato_imagen_b64: String
  ) {
    saveFileRepo(
      archivo_b64: $archivo_b64
      descripcion_archivo: $descripcion_archivo
      formato_b64: $formato_b64
      id_empresa: $id_empresa
      id_usuario: $id_usuario
      nombre_archivo: $nombre_archivo
      tiempo: $tiempo
      tipo_archivo: $tipo_archivo
      inputUri: $inputUri
      filenameInputUri: $filenameInputUri
      fileName: $fileName
      imagen_b64: $imagen_b64
      formato_imagen_b64: $formato_imagen_b64
    ) {
      percent
      uploadStatus
      id_archivo
      nombre_archivo
      url_archivo
      url_imagen
      descripcion_archivo
      tiempo_video
      id_estado_fk
      fecha_creacion
      fecha_modificacion
    }
  }
`;

export const SCREEN_SHOT_SUB = gql`
  subscription SuscripcionCaptura(
    $id_canal: Int
    $id_pantalla: Int
    $tipo_dispositivo: String!
    $identificador_unico: String!
  ) {
    SuscripcionCaptura(
      id_canal: $id_canal
      id_pantalla: $id_pantalla
      tipo_dispositivo: $tipo_dispositivo
      identificador_unico: $identificador_unico
    ) {
      id_pantalla
      id_canal
      id_empresa
      identificador_unico
      tipo_dispositivo
      solicita_captura
      url_captura
      fecha_creacion
    }
  }
`;

export const SAVE_FILE_MAIL_BUILDER_BODY = gql`
  subscription SaveFileBuilderBody(
    $fileName: String
    $filenameInputUri: String
    $inputUri: String
    $tipoContenido: String
    $formatoB64: String
    $archivoB64: String
    $tiempo: String
    $descripcionArchivo: String
    $nombreArchivo: String
    $tipoArchivo: Int
    $idEmpresa: String
    $idUsuario: String
  ) {
    saveFileBuilderBody(
      id_usuario: $idUsuario
      id_empresa: $idEmpresa
      tipo_archivo: $tipoArchivo
      nombre_archivo: $nombreArchivo
      descripcion_archivo: $descripcionArchivo
      tiempo: $tiempo
      archivo_b64: $archivoB64
      formato_b64: $formatoB64
      tipo_contenido: $tipoContenido
      inputUri: $inputUri
      filenameInputUri: $filenameInputUri
      fileName: $fileName
    ) {
      percent
      uploadStatus
      id_archivo
      nombre_archivo
      url_archivo
      url_imagen
      descripcion_archivo
      tiempo_video
      detalle_tipoa {
        id_detalle
        nombre_detalle
        descripcion_detalle
        tipo_archivo {
          id_tipo
          nombre_archivo
          descripcion_archivo
          id_estado_fk
        }
        id_estado_fk
        fecha_creacion
      }
      id_estado_fk
      fecha_creacion
      fecha_modificacion
    }
  }
`;
